/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierType } from '../model';
// @ts-ignore
import type { ContainerHeight } from '../model';
// @ts-ignore
import type { ContainerStatus } from '../model';
// @ts-ignore
import type { ContainerType } from '../model';
// @ts-ignore
import type { SlotDto } from '../model';
// @ts-ignore
import type { StackDto } from '../model';
// @ts-ignore
import type { UnitType } from '../model';
/**
 * YardBlockStacksApi - axios parameter creator
 */
export const YardBlockStacksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {string} [yardBlockId] 
         * @param {string} [yardBlockBayId] 
         * @param {string} [yardBlockRowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockStacksGetYardBlockStacks: async (containerNumber?: string, yardBlockId?: string, yardBlockBayId?: string, yardBlockRowId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockStacks/GetYardBlockStacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumber !== undefined) {
                localVarQueryParameter['ContainerNumber'] = containerNumber;
            }

            if (yardBlockId !== undefined) {
                localVarQueryParameter['YardBlockId'] = yardBlockId;
            }

            if (yardBlockBayId !== undefined) {
                localVarQueryParameter['YardBlockBayId'] = yardBlockBayId;
            }

            if (yardBlockRowId !== undefined) {
                localVarQueryParameter['YardBlockRowId'] = yardBlockRowId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockStacksGetYardBlockStacksAdvanced: async (containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockStacks/GetYardBlockStacksAdvanced`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerOrReferenceNumber !== undefined) {
                localVarQueryParameter['ContainerOrReferenceNumber'] = containerOrReferenceNumber;
            }

            if (inboundCarrierType !== undefined) {
                localVarQueryParameter['InboundCarrierType'] = inboundCarrierType;
            }

            if (outboundCarrierType !== undefined) {
                localVarQueryParameter['OutboundCarrierType'] = outboundCarrierType;
            }

            if (inboundCarrier !== undefined) {
                localVarQueryParameter['InboundCarrier'] = inboundCarrier;
            }

            if (outboundCarrier !== undefined) {
                localVarQueryParameter['OutboundCarrier'] = outboundCarrier;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (containerIsoCode !== undefined) {
                localVarQueryParameter['ContainerIsoCode'] = containerIsoCode;
            }

            if (typeCode !== undefined) {
                localVarQueryParameter['TypeCode'] = typeCode;
            }

            if (portOfLoading !== undefined) {
                localVarQueryParameter['PortOfLoading'] = portOfLoading;
            }

            if (portOfDischarge !== undefined) {
                localVarQueryParameter['PortOfDischarge'] = portOfDischarge;
            }

            if (weightClasses) {
                localVarQueryParameter['WeightClasses'] = weightClasses;
            }

            if (isReefer !== undefined) {
                localVarQueryParameter['IsReefer'] = isReefer;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            if (isRestow !== undefined) {
                localVarQueryParameter['IsRestow'] = isRestow;
            }

            if (containerOperator !== undefined) {
                localVarQueryParameter['ContainerOperator'] = containerOperator;
            }

            if (consignee !== undefined) {
                localVarQueryParameter['Consignee'] = consignee;
            }

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (locationStatus !== undefined) {
                localVarQueryParameter['LocationStatus'] = locationStatus;
            }

            if (containerType !== undefined) {
                localVarQueryParameter['ContainerType'] = containerType;
            }

            if (containerHeight !== undefined) {
                localVarQueryParameter['ContainerHeight'] = containerHeight;
            }

            if (isInTerminal !== undefined) {
                localVarQueryParameter['isInTerminal'] = isInTerminal;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (containerUnitType) {
                localVarQueryParameter['ContainerUnitType'] = containerUnitType;
            }

            if (isOOG !== undefined) {
                localVarQueryParameter['IsOOG'] = isOOG;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [bayId] 
         * @param {string} [rowId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockStacksSetLockStatus: async (bayId?: string, rowId?: string, lockStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockStacks/SetLockStatus/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (bayId !== undefined) {
                localVarQueryParameter['bayId'] = bayId;
            }

            if (rowId !== undefined) {
                localVarQueryParameter['rowId'] = rowId;
            }

            if (lockStatus !== undefined) {
                localVarQueryParameter['lockStatus'] = lockStatus;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlockStacksApi - functional programming interface
 */
export const YardBlockStacksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlockStacksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {string} [yardBlockId] 
         * @param {string} [yardBlockBayId] 
         * @param {string} [yardBlockRowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockStacksGetYardBlockStacks(containerNumber?: string, yardBlockId?: string, yardBlockBayId?: string, yardBlockRowId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StackDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockStacksGetYardBlockStacks(containerNumber, yardBlockId, yardBlockBayId, yardBlockRowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockStacksApi.yardBlockStacksGetYardBlockStacks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockStacksGetYardBlockStacksAdvanced(containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StackDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockStacksGetYardBlockStacksAdvanced(containerOrReferenceNumber, inboundCarrierType, outboundCarrierType, inboundCarrier, outboundCarrier, isEmpty, size, containerIsoCode, typeCode, portOfLoading, portOfDischarge, weightClasses, isReefer, isDamaged, imoClasses, isRestow, containerOperator, consignee, isDangerous, locationStatus, containerType, containerHeight, isInTerminal, customerId, containerUnitType, isOOG, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockStacksApi.yardBlockStacksGetYardBlockStacksAdvanced']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [bayId] 
         * @param {string} [rowId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockStacksSetLockStatus(bayId?: string, rowId?: string, lockStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockStacksSetLockStatus(bayId, rowId, lockStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockStacksApi.yardBlockStacksSetLockStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlockStacksApi - factory interface
 */
export const YardBlockStacksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlockStacksApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockStacksGetYardBlockStacks(requestParameters: YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StackDto>> {
            return localVarFp.yardBlockStacksGetYardBlockStacks(requestParameters.containerNumber, requestParameters.yardBlockId, requestParameters.yardBlockBayId, requestParameters.yardBlockRowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockStacksApiYardBlockStacksGetYardBlockStacksAdvancedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockStacksGetYardBlockStacksAdvanced(requestParameters: YardBlockStacksApiYardBlockStacksGetYardBlockStacksAdvancedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StackDto>> {
            return localVarFp.yardBlockStacksGetYardBlockStacksAdvanced(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockStacksApiYardBlockStacksSetLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockStacksSetLockStatus(requestParameters: YardBlockStacksApiYardBlockStacksSetLockStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlotDto>> {
            return localVarFp.yardBlockStacksSetLockStatus(requestParameters.bayId, requestParameters.rowId, requestParameters.lockStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlockStacksGetYardBlockStacks operation in YardBlockStacksApi.
 */
export interface YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest {
    readonly containerNumber?: string

    readonly yardBlockId?: string

    readonly yardBlockBayId?: string

    readonly yardBlockRowId?: string
}

/**
 * Request parameters for yardBlockStacksGetYardBlockStacksAdvanced operation in YardBlockStacksApi.
 */
export interface YardBlockStacksApiYardBlockStacksGetYardBlockStacksAdvancedRequest {
    readonly containerOrReferenceNumber?: string

    readonly inboundCarrierType?: CarrierType

    readonly outboundCarrierType?: CarrierType

    readonly inboundCarrier?: number

    readonly outboundCarrier?: number

    readonly isEmpty?: boolean

    readonly size?: number

    readonly containerIsoCode?: string

    readonly typeCode?: string

    readonly portOfLoading?: string

    readonly portOfDischarge?: string

    readonly weightClasses?: Array<string>

    readonly isReefer?: boolean

    readonly isDamaged?: boolean

    readonly imoClasses?: Array<string>

    readonly isRestow?: boolean

    readonly containerOperator?: string

    readonly consignee?: string

    readonly isDangerous?: boolean

    readonly locationStatus?: ContainerStatus

    readonly containerType?: ContainerType

    readonly containerHeight?: ContainerHeight

    readonly isInTerminal?: boolean

    readonly customerId?: number

    readonly containerUnitType?: Array<UnitType>

    readonly isOOG?: boolean
}

/**
 * Request parameters for yardBlockStacksSetLockStatus operation in YardBlockStacksApi.
 */
export interface YardBlockStacksApiYardBlockStacksSetLockStatusRequest {
    readonly bayId?: string

    readonly rowId?: string

    readonly lockStatus?: boolean
}

/**
 * YardBlockStacksApi - object-oriented interface
 */
export class YardBlockStacksApi extends BaseAPI {
    /**
     * 
     * @param {YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockStacksGetYardBlockStacks(requestParameters: YardBlockStacksApiYardBlockStacksGetYardBlockStacksRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockStacksApiFp(this.configuration).yardBlockStacksGetYardBlockStacks(requestParameters.containerNumber, requestParameters.yardBlockId, requestParameters.yardBlockBayId, requestParameters.yardBlockRowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockStacksApiYardBlockStacksGetYardBlockStacksAdvancedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockStacksGetYardBlockStacksAdvanced(requestParameters: YardBlockStacksApiYardBlockStacksGetYardBlockStacksAdvancedRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockStacksApiFp(this.configuration).yardBlockStacksGetYardBlockStacksAdvanced(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockStacksApiYardBlockStacksSetLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockStacksSetLockStatus(requestParameters: YardBlockStacksApiYardBlockStacksSetLockStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockStacksApiFp(this.configuration).yardBlockStacksSetLockStatus(requestParameters.bayId, requestParameters.rowId, requestParameters.lockStatus, options).then((request) => request(this.axios, this.basePath));
    }
}

